import axios from "axios";
import { buildQuery } from "utils/queryUtils";

import * as yup from "yup";

let schema = yup.object().shape({
    jobKey: yup.string().test("not-blank", "jobKey.required", (application) => application?.length > 0),
    jobName: yup.string().test("not-blank", "jobName.required", (profile) => profile?.length > 0),
    className: yup.string().test("not-blank", "label.required", (label) => label?.length > 0),
    jobGroup: yup.string().test("not-blank", "jobGroup.required", (key) => key?.length > 0),
    cronExpression: yup.string().test("not-blank", "cronExpression.required", (value) => value?.length > 0),
    configRow: yup.string().test("not-blank", "configRow.required", (value) => value?.length > 0),
});

export const validateConfig = (config) => {
    return schema.validate(config, { abortEarly: false });
};
export const findVNeIDJob = (headers, params, body) => {
    let query = buildQuery(params, ["jobName"]);
    return axios.post(`${process.env.REACT_APP_JOB_API_URL}/quartz-job/search${query}`, body, { headers });
};
export const createVNeIDJob = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_JOB_API_URL}/quartz-job/saveOrUpdate`, data, { headers });
};
export const updateVNeIDJob = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_JOB_API_URL}/quartz-job/saveOrUpdate`, data, { headers });
};
export const deleteVNeIDJob = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_JOB_API_URL}/quartz-job/deleteJob`, data, { headers });
};
export const pauseVNeIDJob = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_JOB_API_URL}/quartz-job/pauseJob`, data, { headers });
};
export const resumeVNeIDJob = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_JOB_API_URL}/quartz-job/resumeJob`, data, { headers });
};
export const reloadVNeIDJob = (headers) => {
    return axios.get(`${process.env.REACT_APP_JOB_API_URL}/quartz-job/check-job-running`, { headers });
};
export const callNodeVNeIDJob = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_JOB_API_URL}/quartz-job/call-node`, data, { headers });
};
export const listServerVNeIDJob = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_JOB_API_URL}/quartz-job/server/list`, data, { headers });
};
export const listServiceNameVNeIDJob = (headers, data) => {
    return axios.get(`${process.env.REACT_APP_JOB_API_URL}/quartz-job/app-name`, { headers });
};
export const listSuggestion = (headers, server) => {
    return axios.get(`${process.env.REACT_APP_JOB_API_URL}/quartz-job/suggestions?server=${server}`, { headers });
};
